<template>
  <v-row no-gutters class="head_bgActivity card cardbg">
    <v-app-bar style="background-color: #ffff; min-height: 6vh" fixed dense>
      <v-col class="pa-0" cols="2" @click="goBack()" icon>
        <v-icon align="center" color="orange">mdi-arrow-left</v-icon>
      </v-col>
      <v-col cols="8" class="d-flex justify-center" style="font-size: 20px">
        {{ $t("message.chooseAddress") }}
      </v-col>
      <v-col cols="2" style="font-size: 20px"> </v-col>
    </v-app-bar>
    <v-col style="background-color: #fff" class="cardbg">
      <div class="mt-7">
        <v-fade-transition mode="out-in">
          <v-row style="padding: 20px; font-weight: bold">
            <v-col cols="6" style="margin-bottom: 0px"
              >{{ $t("message.chooseAddress") }}</v-col
            >
            <v-col cols="1" style="margin-bottom: 0px"></v-col>
            <v-col
              align="right"
              cols="5"
              style="margin-bottom: 0px"
              @click="expand2 = !expand2, form.postalCode = '', form.numAddress = '',form.district ='',form.subDistrict= '',form.provinces=''"
              >{{ $t("message.addAddress") }}<v-icon
                style="margin-left: 8px"
                align="center"
                color="orange"
                >mdi-plus-circle</v-icon
              ></v-col
            >
            <v-expand-transition>
              <v-card
                v-show="expand2"
                height="auto"
                width="100vh"
                class="mx-auto pa-2"
              >
                <v-form v-model="valid" lazy-validation>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="form.nameSurname"
                        :rules="[v => !!v || `${this.$t('message.plsFillName')}`]"
                        color="purple darken-2"
                        :label="`${this.$t('message.nameSurname')}`"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="form.tel"
                        :rules="[v => !!v || `${this.$t('message.plsFillTel')}`]"
                        color="purple darken-2"
                        :label="`${this.$t('message.tel')}`"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="form.numAddress"
                        :rules="[v => !!v || `${this.$t('message.plsAddressNum')}`]"
                        color="purple darken-2"
                        :label="`${this.$t('message.detailAdrres')}`"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="form.postalCode"
                        :rules="[v => !!v || `${this.$t('message.plsPoscal')}`, v => (!isNaN(v)) && v.length >= 5 && v.length <= 5  || `${this.$t('message.plsPoscalNotic')}`, resZipCode.length > 0 || `${this.$t('message.notFoundPoscal')}`]"
                        color="purple darken-2"
                        :label="`${this.$t('message.poscal')}`"
                        no-data-text="คิวเต็มแล้ว"
                        required
                        @input="addAddress()"
                      ></v-text-field
                    ></v-col>
                  </v-row>
                  <div>
                    <v-select
                      v-model="form.subDistrict"
                      :items="optionSubDistrict"
                      :rules="[v => !!v || `${this.$t('message.plsFillSubDistrict')}`]"
                      filled
                      :no-data-text="`${this.$t('message.plsPoscal')}`"
                      :label="`${this.$t('message.subDistrict')}`"
                    ></v-select>
                    <v-select
                      v-model="form.district"
                      :items="optionDistrict"
                      :rules="[v => !!v || `${this.$t('message.plsFillDistrict')}`]"
                      filled
                      :no-data-text="`${this.$t('message.plsPoscal')}`"
                      :label="`${this.$t('message.district')}`"
                    ></v-select>
                    <v-select
                      v-model="form.provinces"
                      :items="optionProvinces"
                      :rules="[v => !!v || `${this.$t('message.plsFillProvince')}`]"
                      filled
                      :no-data-text="`${this.$t('message.plsPoscal')}`"
                      :label="`${this.$t('message.province')}`"
                    ></v-select>
                  </div>
                  <v-col align="center">
                    <v-btn
                      v-if="!loadingbtn"
                      color="orange"
                      :loading="loadingbtn"
                      :disabled="!valid || !form.postalCode || !form.numAddress || !form.district || !form.subDistrict || !form.provinces"
                      @click="loadingbtn = true,addDataAddres()"
                    >
                    {{ $t("message.addAddress") }}
                    </v-btn>
                    <!-- <v-col v-if="loadingbtn" cols="12">
                            <v-btn disabled elevation="2" loading></v-btn>
                    </v-col> -->
                    <!-- <v-btn
                      class="ma-2"
                      :loading="loading4"
                      :disabled="loading4"
                      color="info"
                      @click="loader = 'loading4'"
                    >
                      Icon Loader
                      <template v-slot:loader>
                        <span class="custom-loader">
                          <v-icon light>mdi-cached</v-icon>
                        </span>
                      </template>
                    </v-btn> -->
                  </v-col>
                </v-form>
              </v-card>
            </v-expand-transition>
            <TransitionGroup name="fade" class="container">
              <v-col v-for="item in allAddres" :key="item.idUserAddress">
                <v-card color="#385F73" dark class="mb-2">
                  <v-card-title class="text-h6" style="margin-bottom: 5px">
                    <v-icon>mdi-map-marker-outline</v-icon>
                    <strong>{{ item.nameOfAddress }}</strong>
                  </v-card-title>
                  <v-card-subtitle style="padding-bottom: 0px"
                    >{{ item.houseNumber }}. {{ $t("message.subDistrict") }} {{ item.subDistrict }}. อำเภอ {{ item.district }}. {{ $t("message.province") }} {{ item.provinces }}. {{ item.postalCode }}.</v-card-subtitle
                  >

                  <v-card-actions style="padding: 15px">
                    <v-btn outlined color="orange" @click="selectAddres(item)">
                      {{ $t("message.selectAddress") }}
                      <v-icon
                        small
                        style="margin-left: 8px"
                        align="left"
                        color="orange"
                        >mdi-cursor-default-outline</v-icon
                      >
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </TransitionGroup>
          </v-row>
        </v-fade-transition>
      </div>
    </v-col>
  </v-row>
</template>
<style scoped>
.card1 {
  height: 100%;
  overflow: hidden;
  background-color: #fff !important;
  border-radius: 0px 0px 0px 0px;
}
.card {
  height: 100%;
  overflow: hidden;
}
.cardbg {
  margin-top: 10px;
  background-repeat: no-repeat !important;
  background-size: 90% 110% !important;
  background-attachment: fixed;
  background-position: center;
}
</style>
<script>
import HeaderProfile from '../../HeaderProfile'
import MenuItem from '../../MenuItem'
import AllActivity from '../../AllActivity'
import axios from 'axios'
import moment from 'moment-timezone'
import Swal from 'sweetalert2'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ActivityMain',
  components: {
    'header-profile': HeaderProfile,
    'menu-item': MenuItem,
    'all-activity': AllActivity
  },
  data () {
    return {
      id: this.$route.params.id,
      loadingbtn: false,
      member: null,
      profile: null,
      reward: null,
      valid: true,
      rewardId: null,
      shopId: null,
      address: [
        {
          nameAdd: `ที่อยู่ 1`,
          address: 'ตำบล ประชาธิปัตย์ อำเภอธัญบุรี ปทุมธานี 12130.'
        },
        {
          nameAdd: 'ที่อยู่ 2',
          address: 'ตำบล ประชาธิปัตย์ อำเภอธัญบุรี ปทุมธานี 12130.'
        }
      ],
      optionDistrict: [],
      optionSubDistrict: [],
      optionProvinces: [],
      form: {
        postalCode: '',
        district: '',
        subDistrict: '',
        provinces: '',
        numAddress: '',
        nameSurname: '',
        tel: ''
      },
      allAddres: [],
      expand2: false,
      resZipCode: [],
      loader: null,
      loading: false,
      loading2: false,
      loading3: false,
      loading4: false,
      loading5: false
    }
  },
  watch: {
    loader () {
      const l = this.loader
      this[l] = !this[l]

      setTimeout(() => (this[l] = false), 3000)

      this.loader = null
    }
  },
  async mounted () {
    window.scrollTo(0, 0)
    this.member = this.GET_MEMBERINFO()
    this.profile = this.getLiffProfile()
    this.shopId = this.GET_SHOPID()

    await this.getAddress()
  },
  methods: {
    ...mapActions('memberStore', ['getMemberProfile']),
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),
    ...mapGetters('shopStore', ['GET_SHOPID']),

    async getAddress () {
      const result = await this.callBeTaskAPI('get', `/AddressUser/get?shopId=${this.shopId}&memberId=${this.profile.memberId}`)
      if (Array.isArray(result)) {
        this.allAddres = result
      }
    },
    async selectAddres (address) {
      const result = await this.callBeTaskAPI('get', `/reward/getID?rewardId=${this.id}`)
      if (result) {
        this.reward = result
      }
      Swal.fire({
        title: `${this.$t('message.ConfirmReward')}`,
        html: `<img src="${this.reward.pictureUrl}" width="120"/><br><br><b>${this.reward.name}</b><br>${this.$t('message.use')} <font color="red">${this.reward.point}</font> ${this.$t('message.point')}<br><br>${this.$t('message.sendRewardAddress')} <br><b>${address.houseNumber}. ${this.$t('message.subDistrict')} ${address.subDistrict}. ${this.$t('message.district')} ${address.district}. ${this.$t('message.province')} ${address.provinces}. ${address.postalCode}.</b>`,
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: `${this.$t('message.confirm')}`,
        cancelButtonText: `${this.$t('message.cancle')}`,
        allowOutsideClick: false
      }).then(async (confirm) => {
        if (confirm.isConfirmed) {
          const params = {
            redeemStatus: 'use',
            rewardId: this.reward.rewardId,
            supply: this.reward.supply,
            addressId: address.idUserAddress
          }
          const result1 = await this.callBeTaskAPI('post', `/rewardCode/edit`, params)
          await this.getMemberProfile()
          this.member = this.GET_MEMBERINFO()
          Swal.fire({
            title: `${this.$t('message.completeReward')}`,
            html: `code: <font color="red">${result1.rewardCode}</font><br>${this.$t('message.deliveryAdd')}<br><b>${address.houseNumber}. ${this.$t('message.subDistrict')} ${address.subDistrict}. ${this.$t('message.district')} ${address.district}. ${this.$t('message.province')} ${address.provinces}. ${address.postalCode}.</b>`,
            icon: 'success',
            allowOutsideClick: false,
            showCancelButton: false,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#b3b1ab',
            confirmButtonText: `${this.$t('message.Viewrewards')}`,
            cancelButtonText: `${this.$t('message.cancle')}`
          }).then((confirm) => {
            if (confirm.isConfirmed) {
              setTimeout(() => { window.location.href = '/C/card' }, 50)
            }
          })
        }
      })
    },
    async addDataAddres () {
      var idMember = moment().valueOf()
      // const body = {
      //   'idUserAddress': 'IDAD' + idMember,
      //   'nameOfAddress': `ที่อยู่ 1`,
      //   'postalCode': '12312',
      //   'district': 'test',
      //   'subDistrict': '12312',
      //   'provinces': 'ปทุมธานี',
      //   'houseNumber': 'test',
      //   'lineUserId': this.profile.userId,
      //   'shopId': this.$session.getAll().shopId,
      //   'CREATE_USER': 'ffff',
      //   'LAST_USER': 'eeeee'
      // }
      const body = {
        'idUserAddress': 'IDAD' + idMember,
        'nameSurname': this.form.nameSurname,
        'tel': this.form.tel,
        'nameOfAddress': `${this.$t('message.addressNo')} ${this.allAddres.length + 1}`,
        'postalCode': this.form.postalCode,
        'district': this.form.district,
        'subDistrict': this.form.subDistrict,
        'provinces': this.form.provinces,
        'memberId': this.profile.memberId,
        'houseNumber': this.form.numAddress,
        'lineUserId': this.profile.userId,
        'shopId': this.shopId,
        'CREATE_USER': this.profile.userId,
        'LAST_USER': this.profile.userId
      }
      const result = await this.callBeTaskAPI('post', `/AddressUser/add`, body)
      this.loadingbtn = false
      if (result.status === true) {
        const Toast = Swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 1500,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
          }
        })

        Toast.fire({
          icon: 'success',
          title: `${this.$t('message.seccessAddress')}`,
          backdrop: `rgba(0,0,001,0.2)`,
          width: '100vh'
        })
        this.optionDistrict = []
        this.optionSubDistrict = []
        this.optionProvinces = []
        this.form.postalCode = ''
        this.form.numAddress = ''
        this.expand2 = !this.expand2
        setTimeout(() => (this.allAddres.unshift(body)), 2000)
      } else {
      }
    },
    async addAddress () {
      if (this.form.postalCode.length >= 5) {
        this.optionDistrict = []
        this.optionSubDistrict = []
        this.optionProvinces = []
        await axios
          .get(
            // eslint-disable-next-line quotes
            "https://api-belinked.betaskthai.tech/location/map_thai?zipcode=" +
              this.form.postalCode
          )
          .then(async (response) => {
            this.resZipCode = response.data
            // this.form.provinve = response.data[0].province
            // this.form.district = response.data[0].district
            let rs = response.data
            // this.form.provinve = response.data[0].province
            for (var i = 0; i < rs.length; i++) {
              var x = rs[i]
              var z = {}
              z.text = x.district
              z.value = x.district
              this.optionDistrict.push(z)

              var d = rs[i]
              var s = {}
              s.text = d.sub_district
              s.value = d.sub_district
              this.optionSubDistrict.push(s)
            }
            for (var t = 0; t < rs.length; t++) {
              var k = rs[t]
              var l = {}
              l.text = k.province
              l.value = k.province
              this.optionProvinces.push(l)
            }
          }) // eslint-disable-next-line handle-callback-err
          .catch((error) => {
            console.error(error)
            // this.$swal('ผิดพลาด', 'ไม่มีข้อมูล', 'error')
          })
      } else if (this.form.postalCode.length < 5) {
        console.error('น้อยกว่า')
        this.optionDistrict = []
        this.optionSubDistrict = []
        this.optionProvinces = []
        this.form.postalCode = ''
        this.form.district = ''
        this.form.provinces = ''
      }
    },
    goBack () {
      window.history.back()
    },
    remove (item) {
      const i = this.items.indexOf(item)
      if (i > -1) {
        this.items.splice(i, 1)
      }
    }
  }
}
</script>
<style scoped>
div.sticky {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
}
.container {
  position: relative;
  padding: 0;
}
.item {
  width: 100%;
  height: 30px;
  background-color: #f3f3f3;
  border: 1px solid #666;
  box-sizing: border-box;
}

/* 1. declare transition */
.fade-move,
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
}

/* 2. declare enter from and leave to state */
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: scaleY(0.01) translate(30px, 0);
}

/* 3. ensure leaving items are taken out of layout flow so that moving
      animations can be calculated correctly. */
.fade-leave-active {
  position: absolute;
}
.custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/HomeCUSTOM/Reward/UserAddress.vue